import type { ReactNode, ComponentPropsWithoutRef } from 'react';

export type DataListItemProps = Omit<ComponentPropsWithoutRef<'dl'>, 'children'> & {
  /**
   * Should only contain `DataListItemLabel` and `DataListItemValue` components.
   */
  children: ReactNode;
};

/**
 * An item within a `DataList`. It should only contain `DataListItemLabel` and `DataListItemValue` components.
 */
// eslint-disable-next-line @typescript-eslint/promise-function-async
export const DataListItem = ({ children }: DataListItemProps) => {
  return children;
};

DataListItem.displayName = 'DataListItem';
